import React, { useState, useRef } from 'react';
import TagInput from '../components/TagInput';

export default function AddCard() {
  const [body, setBody] = useState('');
  const [tags, setTags] = useState([]);
  const [saving, setSaving] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const tagInputRef = useRef();

  const handleSave = async () => {
    if (!body.trim()) { setError('Card cannot be empty.'); return; }
    // Flush any unconfirmed tag text before saving
    const finalTags = tagInputRef.current ? tagInputRef.current.flush() : tags;
    setSaving(true);
    setError('');
    try {
      const res = await fetch('/api/cards', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ body: body.trim(), tags: finalTags }),
      });
      if (res.ok) {
        setBody('');
        setTags([]);
        setSuccess(true);
        setTimeout(() => setSuccess(false), 2500);
      } else {
        setError('Failed to save. Try again.');
      }
    } catch {
      setError('Connection error.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ maxWidth: 640 }}>
      <div className="page-header">
        <h1>Add a Card</h1>
        <div className="subtitle">A scrap of dialogue, an object, a moment — anything worth keeping.</div>
      </div>

      {success && (
        <div style={{ background: 'var(--yes)', color: 'white', padding: '0.75rem 1rem', borderRadius: 'var(--radius)', marginBottom: '1rem', fontFamily: 'sans-serif', fontSize: '0.95rem' }}>
          Card saved to the box.
        </div>
      )}

      <div className="form-group">
        <label className="form-label">The Scrap</label>
        <textarea
          className="form-textarea"
          value={body}
          onChange={e => setBody(e.target.value)}
          placeholder="Write anything here — dialogue overheard, an object noticed, a situation, a feeling..."
          rows={3}
          autoFocus
          onKeyDown={e => {
            if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) handleSave();
          }}
        />
        <div className="cmd-enter-hint" style={{ color: 'var(--text-muted)', fontSize: '0.8rem', fontFamily: 'sans-serif', marginTop: '0.25rem' }}>
          Cmd+Enter to save
        </div>
      </div>

      <div className="form-group">
        <label className="form-label">Tags (optional)</label>
        <TagInput ref={tagInputRef} value={tags} onChange={setTags} />
      </div>

      {error && <p style={{ color: 'var(--no)', fontFamily: 'sans-serif', fontSize: '0.9rem', marginBottom: '0.75rem' }}>{error}</p>}

      <button className="btn btn-primary" onClick={handleSave} disabled={saving || !body.trim()}>
        {saving ? 'Saving...' : 'Save to Box'}
      </button>
    </div>
  );
}
